import Model from './Model'
import Report from './Report'

export default class Post extends Model {
  resource() {
    return 'posts'
  }

  reports() {
    return this.hasMany(Report)
  }
}
